import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { id: 'hero', label: '首页' },
  { id: 'updates', label: '最新更新' },
  { id: 'carousel', label: '精选专题' },
  { id: 'features', label: '平台优势' },
  { id: 'cards', label: '影视推荐' },
  { id: 'topics', label: '热门话题' },
  { id: 'app', label: '移动观影' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const headerHeight = 64;
      const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('hero'); }}
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-fill text-background-50 text-lg"></i>
            </span>
            <span className="text-foreground-900 font-heading text-xl font-bold tracking-wide">
              哈哈影院
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.id); }}
                className={`whitespace-nowrap px-3 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                  item.id === 'hero'
                    ? 'text-accent-500 hover:text-accent-400'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/50'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Mobile Toggle */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-600 hover:text-foreground-900 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Nav Panel */}
        {mobileOpen && (
          <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60 py-3">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.id); }}
                className={`block px-4 py-3 text-sm font-medium transition-colors cursor-pointer ${
                  item.id === 'hero'
                    ? 'text-accent-500'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200/30'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
}